export default __webpack_public_path__ + "static/covid-care-service-clinical-img-3cac790ecad4ebba6804c5b7a1cce4eb.png";